import { NumberFormatValues } from "@common/schemas/domains/reportSettings/number-format-setting.schema";
import { formatPreviewAmount } from "./formatPreviewAmount";
import styles from "./ReportPreview.module.scss";

interface Props {
    value: number | undefined;
    numberFormat: NumberFormatValues;
}

/** Right-aligned monetary cell shared by every preview table shape. */
export const AmountCell = ({ value, numberFormat }: Props) => {
    if (value === undefined) {
        return <span className={styles.amountCell} />;
    }
    const amount = formatPreviewAmount(value, numberFormat);
    return (
        <span
            className={styles.amountCell}
            data-negative={
                amount.isNegative && numberFormat.isNegativeInRed
                    ? true
                    : undefined
            }
        >
            {amount.text}
        </span>
    );
};
